import React from "react";
import { Button, DatePicker, Input, Upload } from "antd";
import { PaperClipOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import * as dayjs from "dayjs";

const CrmContactMomentFields = ({
  dateTime,
  onDateTimeChange,
  text,
  onTextChange,
  fileList,
  onFileListChange,
  dateTimePlaceholderKey = "date_time",
  textPlaceholderKey = "describe_contact_moment",
}) => {
  const { t } = useTranslation();

  return (
    <div style={{ marginBottom: 12 }}>
      <DatePicker
        showTime={{ format: "HH:mm" }}
        format="DD-MM-YYYY HH:mm"
        value={dateTime ? dayjs(dateTime) : null}
        onChange={(val) => onDateTimeChange(val ? val.toDate() : null)}
        placeholder={t(dateTimePlaceholderKey)}
        style={{ width: "100%", marginBottom: 12 }}
      />
      <Input.TextArea
        placeholder={t(textPlaceholderKey)}
        value={text}
        onChange={(e) => onTextChange(e.target.value)}
        autoSize={{ minRows: 3, maxRows: 8 }}
        style={{ marginBottom: 12 }}
      />
      <Upload
        multiple
        beforeUpload={() => false}
        fileList={fileList}
        onChange={({ fileList: next }) => onFileListChange(next)}
      >
        <Button icon={<PaperClipOutlined />}>{t("add_attachment")}</Button>
      </Upload>
    </div>
  );
};

export default CrmContactMomentFields;
